import { ParentChildMap } from "PFApp/helpers/get_parent_child_skills_map";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { CustomValue } from "PFCore/types";

type ParentChildInfo = {
  hasChildValues: boolean;
  hasParentValues: boolean;
};

export const getCustomValueParentChildInfo = (
  customValue: Pick<CustomValue, "globalId" | "global_id">,
  parentChildMap?: ParentChildMap
): ParentChildInfo => {
  const globalId = getAttribute(customValue, "globalId");

  if (!globalId || !parentChildMap || !parentChildMap[globalId]) {
    return {
      hasChildValues: false,
      hasParentValues: false
    };
  }

  return {
    hasChildValues: parentChildMap[globalId].childValues.length > 0,
    hasParentValues: parentChildMap[globalId].parentValues.length > 0
  };
};
